/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomFieldsSchemaDto } from '../../models/custom-fields-schema-dto';

export interface GetCustomFieldsSchema$Params {
  id: string;
}

export function getCustomFieldsSchema(http: HttpClient, rootUrl: string, params: GetCustomFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomFieldsSchemaDto>> {
  const rb = new RequestBuilder(rootUrl, getCustomFieldsSchema.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomFieldsSchemaDto>;
    })
  );
}

getCustomFieldsSchema.PATH = '/v0/CustomFieldsSchema/{id}';
